/** Venue tier filter config — leaf module (no component imports). */

// Order is the display order of the filter chips, widest first.
//
// 'festival' used to sit inside the arenas bucket (then called Big Events); it
// is its own filter now, so arenas is stadium + arena only. Values are internal
// keys, not persisted anywhere — EventsList holds the selection in component
// state and defaults to 'all' — so renaming them does not strand a saved filter.
export const VENUE_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'festivals', label: 'Festivals', tiers: ['festival'] },
  { value: 'arenas', label: 'Arenas', tiers: ['stadium', 'arena'] },
  { value: 'theaters', label: 'Theaters', tiers: ['theatre', 'club'] },
  { value: 'intimate', label: 'Bars', tiers: ['intimate', 'bar'] },
];

export function eventMatchesVenueFilter(event, filterValue) {
  if (filterValue === 'all') return true;

  const filter = VENUE_FILTERS.find((f) => f.value === filterValue);
  if (!filter || !filter.tiers) return true;

  const eventTier = event.venues?.venue_tier || event.venue_tier || 'other';
  return filter.tiers.includes(eventTier);
}
